import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { init } from '../../auth/handleTokens';
import { constants } from '../../constants';
import NotificationContext from '../toasts/NotificationContext';
import ModalAuthMessage from './ModalAuthMessage';

const ApprovedMessages = (props) => {
    const toggle = props.toggleSidebar ? '240px' : '10px';
    const [messages, setMessages] = useState([]);
    const [changeMessages, setChangeMessages] = useState(false);
    const [renderModalMessage, setRenderModalMessage] = useState(false)
    const [idMessage, setIdMessage] = useState('')
    const [contentMessage, setContentMessage]= useState('');
    const [charactersCount, setCharactersCount] = useState(0);
    const [creditsCount, setCreditsCount] = useState(0);

    const {showNotification} = useContext(NotificationContext);

    const getMessages =  async() => {
        try {
          const result = await init();
          if(!result) return window.location.href = '/login';
          const token = window.localStorage.getItem('at');
          const URL = constants.test_host + '/sms/get-auth-messages';
          const {data} = await axios.get(URL, {headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true})
          setMessages(data.authMessages);
          return
          
         } catch (error) {
            console.log(error)
         }
    }

    const refreshMessage = () => {
      setChangeMessages(!changeMessages);
    }

    const selectionMessage = async(target, action) => {
        const result = await init();
        if(!result) return window.location.href = '/login';
        const token = window.localStorage.getItem('at');
        switch (action) {
          case 'delete':
            const URL = constants.test_host + '/sms/disabledmessage/' + target.offsetParent.id;
            await axios.put(URL, {}, {headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true})
            .then(({data}) => {
              setChangeMessages(!changeMessages);
              return showNotification('success', data.message)
            })
          
            break;
          case 'send':
            setRenderModalMessage(true)
            setIdMessage(target.offsetParent.id)
            setContentMessage(target.offsetParent.parentElement.children[1].innerText);
            setCharactersCount(target.offsetParent.parentElement.children[2].innerText);
            setCreditsCount(target.offsetParent.parentElement.children[3].innerText);
              break
      
          default:
              break;
      }

        

    }
  

    const tableMessages = messages.map((item, index) =>
      <tr key={item._id}>
        <td>{index + 1}</td>
        <td style={{textAlign: 'justify'}}>{item.content}</td>
        <td title='Número de caracteres' style={{textAlign: 'justify'}}>{item.characters}</td>
        <td title='Número de créditos' style={{textAlign: 'justify'}}>{item.credits}</td>
        <td style={{textAlign: 'justify'}}>{item.dateRequest}</td>
        <td style={{textAlign: 'justify'}}>{item.dateAuth}</td>
        <td id={item._id} style={{textAlign: 'justify'}}> <a title='Eliminar mensaje' className='btn-sm btn btn-primary' onClick={(e) => selectionMessage(e.target, 'delete')}><i class="fas fa-times-circle"></i></a>  <a title='Enviar mensaje' className='btn-sm btn btn-primary' onClick={(e) => selectionMessage(e.target, 'send')} href="#messageAuthModal" role="button" data-bs-toggle="modal"><i class="fas fa-paper-plane"></i></a></td>
      </tr>
    )
    
    useEffect(()=> {
        getMessages();
    }, [changeMessages])

    return (
      <div className="content-wrapper content" style={{ marginLeft: `${toggle}`, transition: "all 0.5s" }} >
        <h6 style={{textAlign: 'left', paddingLeft:'5px', fontSize:'smaller'}}>Mensaje aprobados: <button onClick={() => refreshMessage()} title='Refrescar' className='btn btn-sm btn-primary'><i className="fas fa-sync-alt"></i></button> </h6>
        <table className="table table-striped" style={{fontSize:'small', textAlign: 'justify'}}>
          <thead>
            <tr>
              <th>#Id</th>
              <th>Mensaje</th>
              <th title='Número de caracteres'>Caract</th>
              <th title='Número de créditos'>Cred</th>
              <th>F.Solicitud</th>
              <th>F.Aprobado</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {tableMessages}
          </tbody>
        </table>

        <div id="messageAuthModal" className="modal fade" tabIndex="-1">
          <div className="modal-dialog">
            <div className='modal-content font-mulish'>
              {renderModalMessage && <ModalAuthMessage id= {idMessage} setIdMessage={setIdMessage} contentMessage={contentMessage} charactersCount={charactersCount} creditsCount={creditsCount} />}
            </div>
          </div>
        </div>
      </div>
    )
}


export default ApprovedMessages
